module.exports = ".highlight-row{\n    background-color: #0095ba;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/confirm-deposit/confirm-deposit.component.css
// module id = ./src/app/components/confirm-deposit/confirm-deposit.component.css
// module chunks = main